/* eslint-disable import/prefer-default-export */
import store from '@/store/index';
import axios from 'axios';
import { Notify } from 'quasar';

// Route protection
export function ifAuthenticated(to, from, next) {
  axios
    .get('me')
    .then(() => {
      next();
    })
    .catch(() => {
      next('/login');
    });
}

export function allowModuleAccess(to, from, next) {
  // Check module-level route access. (users, usergroups, blog, library)
  const modules = store.state.meStore.me.rights
    .map(x => x.split('.')[0])
    .filter((item, pos, self) => self.indexOf(item) === pos);

  if (modules.includes(to.meta.permission) || store.state.meStore.me.su) {
    next();
    return;
  }
  Notify.create({
    message: store.state.stringsStore.strings.error.permission,
    position: 'top-right',
    color: 'warning',
    timeout: 2000,
  });
  next('/dashboard');
}

export function hasRights(to, from, next) {
  // Allow route access when user is su or has correct permission.
  if (store.state.meStore.me.su || store.state.meStore.me.rights.includes(to.meta.permission)) {
    next();
    return;
  }
  Notify.create({
    message: store.state.stringsStore.strings.error.permission,
    position: 'top-right',
    color: 'warning',
    timeout: 2000,
  });

  // If the user does not have the correct permission, redirect to dashboard.
  next('/dashboard');
}

export function pageNotFound(to, from, next) {
  // Create a not found page
  next('/dashboard');
}
